export const START_PROFILE_UPDATE = "START_PROFILE_UPDATE";
export const PROFILE_UPDATE_ERROR = "PROFILE_UPDATE_ERROR";
export const PROFILE_UPDATE_SUCCESSFUL = "PROFILE_UPDATE_SUCCESSFUL";
export const END_PROFILE_UPDATE = "END_PROFILE_UPDATE";
